const DATAURI_PREFIX_MEDIA_TYPE_RE = /:(.*?);/;

export const dataURLtoBlob = (dataurl: string) => {
  const arr = dataurl.split(","),
    mime = arr?.[0]?.match(DATAURI_PREFIX_MEDIA_TYPE_RE)?.[1] ?? "",
    bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], { type: mime });
};

export const dataURLtoMimeType = (dataurl: string) => {
  const commaPos = dataurl.indexOf(",");
  const dataPrefix = dataurl.substring(0, commaPos);
  return dataPrefix.match(DATAURI_PREFIX_MEDIA_TYPE_RE)?.[1] ?? "";
};

export const dataURLtoSizeBytes = (dataurl: string) => {
  const arr = dataurl.split(",");
  const bstr = atob(arr[1]);
  return bstr.length;
};
